// @flow

import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { fonts } from '@peachjar/components';
import { css, cx } from 'react-emotion';
import { mdFormClasses } from '../md-form.css';

import TotalCost from './TotalCost';
import ProposalBox from './ProposalBox';

const { ProximaNova } = fonts;

const styles = {
  box: css({
    display: 'flex',
    flexDirection: 'column',
    height: '396px',
    minHeight: '396px',
    width: '513px',
    borderRadius: '6px',
    border: 'solid 2px #e6e6e6',
  }),
  boxTop: css({
    width: '509px',
    height: '101px',
    fontSize: '25px',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  boxTopCenter: css({
    display: 'flex',
    alignItems: 'center',
  }),
  schoolInput: css({
    width: '121px',
    height: '44px',
    borderBottom: '2px solid #2d344b',
    textAlign: 'center',
    fontFamily: ProximaNova,
    fontSize: '34px',
    fontWeight: '600',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1.29',
    letterSpacing: 'normal',
    color: '#2d344b',
  }),
  numberOfSchoolsContainer: css({
    marginTop: '0',
  }),
};

// class PricingBox = ({ numberOfSchools, pricePerSchool, handleFormInput }) =>
const Input = ({
  placeholder,
  input,
  label,
  type,
  meta: { touched, error },
}) => (
  <input
    name="numberOfSchools"
    className={styles.schoolInput}
    data-testid="field-numberOfSchools"
    min={1}
    {...input}
    type={type}
    autoFocus
  />
);

type Props = {
  onGetStarted: () => void,
  numberOfSchools: number,
  pricePerSchool: number,
  totalAmount: number,
};

class PricingBox extends Component<Props> {
  commify(num) {
    // Adds a comma to strings longer than 3 characters
    let numericValue = String(num).replace(/[^0-9]+/g, '');
    numericValue = numericValue.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    return numericValue;
  }

  render() {
    const {
      onGetStarted,
      numberOfSchools,
      pricePerSchool,
      totalAmount,
      discountRate,
      MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL,
    } = this.props;
    return (
      <div className={styles.box}>
        <div className={styles.boxTop}>
          <div className={styles.boxTopCenter}>
            <span>We have</span>
            <div className={cx(mdFormClasses, styles.numberOfSchoolsContainer)}>
              <Field name="numberOfSchools" type="number" component={Input} />
            </div>

            <span>
              {String(numberOfSchools) === '1'
                ? `school ${String.fromCharCode(160)}`
                : 'schools'}
            </span>
          </div>
        </div>

        {numberOfSchools > MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL ? (
          <ProposalBox onGetStarted={onGetStarted} />
        ) : (
          <TotalCost
            pricePerSchool={pricePerSchool}
            numberOfSchools={numberOfSchools}
            totalCost={this.commify(totalAmount)}
            onGetStarted={onGetStarted}
            discountRate={discountRate}
          />
        )}
      </div>
    );
  }
}

PricingBox = reduxForm({
  form: 'onboarding', //                 <------ same form name
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
})(PricingBox);

export default PricingBox;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/components/PricingBox.jsx